import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { Login } from './components/login'
import { setApiMessage } from './redux/features/globalApiMessageSlice';
// import "./assets/0831/main.css";

// pull it from query string https://localhost:8080/login?companyNumber=1201
// validations
// api call
function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setApiMessage(null))
}, [])
 
  return <Login />;
}

export default App